function trackClickGa() {
  const _gaq = _gaq || []; // eslint-disable-line no-underscore-dangle
  _gaq.push(['_setAccount', 'UA-112955599-1']);
  _gaq.push(['_trackPageview']);

  $('.athlon-link a').on('click', function() {
    _gaq.push(['_trackEvent', 'Click', 'Open weareathlon.com']);
  });
  $('.harrington-starr-link a').on('click', function() {
    _gaq.push(['_trackEvent', 'Click', 'Open harringtonstarr.com']);
  });
  $('.js-subscribe').on('click', function() {
    _gaq.push(['_trackEvent', 'Click', 'Subscribe']);
  });
  $('.js-get-in-touch').on('click', function() {
    _gaq.push(['_trackEvent', 'Click', 'Get in touch']);
  });
  $('.logo-module a').on('click', function() {
    if ($(this).attr('href').indexOf('harringtonstarr') > -1) {
      _gaq.push(['_trackEvent', 'Click', 'Get in touch']);
    } else if ($(this).attr('href').indexOf('athlon') > -1) {
      _gaq.push(['_trackEvent', 'Click', 'Get in touch']);
    }
  });
}

export default { trackClickGa };



// WEBPACK FOOTER //
// ./src/js/custom/trigger-click-ga.js